<template>
  <div class="change-permission-wrapper">
    <ts-table
      :table-data="tableData"
      :table-head="columns"
      :table-title-obj="tableTitleObj"
      :table-select-opt="tableSelectOpt"
      @size-change="handleSizeChange"
      @on-handle-filter="handleFilter"
      @current-change="handleCurrentChange"
      @on-handle-select-info="handleSelectInfo"
    />
  </div>
</template>

<script>
import { Component, Vue } from 'vue-property-decorator'
import TsTable from '@/components/TsTable/TsTable.vue'
import { getActivationUserPage } from '@/api/manage/userManage'
import { registerActivation } from '@/api/users.ts'
import { UserModule } from '../../../store/modules/user'
import commonVar from '@/styles/_commonVar.scss'
@Component({
  name: 'changePermission',
  components: {
    TsTable
  }
})
export default class extends Vue {
  searchParams = {}
  userData = {}
  tableData = {
    data: [],
    currentPage: 0,
    pageSize: 20,
    total: 0
  }

  tableTitleObj = {
    title: '许可证信息',
    options: {
      dropdown: false,
      arr: [
      ]
    }
  }

  columns = [
    {
      type: 'radio',
      defaultValue: ''
    },
    {
      labelName: '许可证名称',
      propName: 'activationKey',
      options: {
        type: 'search'
      }
    },
    {
      labelName: '剩余时间',
      propName: 'remainDays',
      optionArr: [
        {
          type: 'asc',
          name: '升序',
          icon: 'el-icon-top'
        },
        {
          type: 'desc',
          name: '降序',
          icon: 'el-icon-bottom'
        }
      ]
    },
    {
      labelName: '启用状态',
      propName: 'registering',
      options: {
        type: 'select',
        optionArr: [
          {
            label: '已启用',
            id: true
          },
          {
            label: '未启用',
            id: false
          }
        ]
      }
    },
    {
      labelName: '包含权限',
      propName: 'roleResourceInfos'
    }
  ]

  tableSelectOpt = [
    {
      type: 'info',
      name: '确认切换',
      icon: 'el-icon-circle-check',
      color: commonVar.primaryColor
    }
  ]

  mounted () {
    this.userData = JSON.parse(window.sessionStorage.getItem('userData'))
    console.log(this.userData)
    this.handleSearch(this.tableData.currentPage, this.tableData.pageSize)
  }

  handleSizeChange (size) {
    this.tableData.pageSize = size
    this.tableData.currentPage = 0
    this.handleSearch(0, size)
  }

  handleCurrentChange (current) {
    this.tableData.currentPage = current
    this.handleSearch(current, this.tableData.pageSize)
  }

  handleFilter (tags) {
    if (tags.length) {
      this.searchParams = {}
      tags.forEach((item) => {
        const key = item.type
        if (item.params.opt.type) {
          this.searchParams.sortField = key
          this.searchParams.direction = item.params.opt.type
        } else if (item.params.opt.label) {
          this.searchParams[key] = item.params.opt.id
        } else {
          this.searchParams[key] = item.params.opt.value || item.params.opt.type
        }
      })
    } else {
      this.searchParams = {}
    }
    console.log('过滤结果：', tags)
    this.handleSearch(0, this.tableData.pageSize)
  }

  async handleSearch (page = 0, size = 20) {
    const params = Object.assign({}, this.searchParams, {
      userId: this.userData ? this.userData.id : '',
      size,
      page
    })
    const res = await getActivationUserPage(params)
    if (res.statusCode === 0 && res.success) {
      this.tableData.data = res.data.content || []
      if (this.tableData.data.length) {
        this.tableData.data = this.tableData.data.map((item) => {
          if (item.registering) {
            this.columns[0].defaultValue = item.id
          }
          const roleResourceInfos = []
          if (item.roleResourceInfos && item.roleResourceInfos.length) {
            item.roleResourceInfos.forEach((op) => {
              if (op.assigned) {
                roleResourceInfos.push(op.name)
              }
            })
          }
          item = Object.assign({}, item, {
            createTime: item.createTime ? item.createTime.slice(0, 10) : '',
            registering: item.registering ? '启用中' : '未启用',
            roleResourceInfos: roleResourceInfos.length ? roleResourceInfos.join(', ') : ''
          })
          return item
        })
      }
      console.log(this.tableData.data)
      this.tableData.total = res.data.totalElements
    }
  }

  handleSelectInfo (arr, item, idx) {
    console.log('选中内容', arr, '选中信息当前项：', item, '当前索引:' + idx)
    const params = {
      userActivationCodeId: arr[0].id
    }
    registerActivation(params).then(res => {
      if (res.statusCode === 0 && res.success) {
        UserModule.ResetToken()
        this.$router.replace({
          path: '/login'
        })
      }
    })
  }
}
</script>

<style lang="scss" scoped>
.change-permission-wrapper {
  padding: 20px;
}
</style>
